import { render } from "./OldIndependentAcceleratorsView.vue?vue&type=template&id=0f7b16e8&scoped=true"
import script from "./OldIndependentAcceleratorsView.vue?vue&type=script&lang=js"
export * from "./OldIndependentAcceleratorsView.vue?vue&type=script&lang=js"

import "./OldIndependentAcceleratorsView.vue?vue&type=style&index=0&id=0f7b16e8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0f7b16e8"]])

export default __exports__